window.qtee.customDesign = window.qtee.customDesign || {};

const { qtee } = window;

qtee.customDesign.NewBackgroundView = Backbone.Marionette.ItemView.extend({
	template: '/custom-design/templates/background-new',
	ui: {
		bgSlider: '.bgSlider',
		oneBg: '.oneBg',
		bgBack: '.back',
		naviNumbers: '#naviNumbers a'
	},
	events: {
		'click @ui.oneBg:not(.disabled)': 'addBackgroundClick',
		'mousedown @ui.oneBg:not(.disabled)': 'savePatternId',
		'click @ui.bgBack': 'backClick',
		'click @ui.naviNumbers': 'addTabIndex'
	},
	initialize (opts) {

		this.$events = $(qtee.customDesign);
		this.customModel = opts.customModel;
		this.hasBackground = opts.hasBackground;
		this.isPillow = opts.isPillow;
		this.viewState = {
			patternId: null
		};

	},
	templateHelpers () {

		return {
			maxReached:
				!this.hasBackground
				&& this.customModel.elements.pattern.length >= qtee.customDesign.settings.limits.design,
			preview: qtee.customDesign.settings.backgrounds.preview
		};

	},
	onDomRefresh () {

		this.setupView();

	},
	setupView (e, opts) {

		const that = this;
		const pattern = qtee.customDesign.availablePatterns.get('backgrounds');
		if (pattern && pattern.length > 12) {

			that.ui.bgSlider.scrollable({ touch: true });

		} else {

			that.ui.bgSlider.scrollable({ touch: false });

		}
		that.ui.bgSlider.navigator();
		$('#naviNumbers').find('a').attr('href', ' ');

		if (opts && opts.slide) {

			that.ui.bgSlider.scrollable().move(opts.slide);

		}

	},
	savePatternId (e) {

		const target = e.target.tagName === 'IMG' ? $(e.target).parent('.oneBg') : $(e.target);
		this.viewState.patternId = target.data('id');

	},

	/** Add new background */
	addBackgroundClick () {

		const that = this;
		const id = this.viewState.patternId;
		const pattern = qtee.customDesign.availablePatterns.get('backgrounds')[parseInt(id, 10)];
		// loader
		const stopLoader = pattern.PatternId ? this.$events.triggerHandler('startLoader') : null;
		const skipAdd =			(document.referrer.search('/cart/') > -1 || document.referrer.search('/wish-list/') > -1)
			&& qtee.customDesign.sceneLoaded
			&& !qtee.customDesign.sceneCloned;

		// if deleting a background, else
		if (!pattern.PatternId) {

			const background = qtee.customDesign.canvas.getBackground();

			// if there is a background, then delete it, otherwise just hide the menu
			if (background) {

				that.$events.triggerHandler('deleteElement', [ background ]);

			}

			that.$events.triggerHandler('deselected.elements.canvas');

		} else {

			// model and svg-element should be created in synchronous way
			// since we dont know the actual size of pattern/desing element on front-end until we got it from server
			// note the qtee.customDesign.settings.newEl.design.width (height) below are maximum values for width (height)

			const model = that.customModel.elements.pattern.create(
				{
					OriginX: that.customModel.area.Width / 2,
					OriginY: that.customModel.area.Height / 2,
					IsBackground: true,
					PatternId: pattern.PatternId,
					Scale: that.isPillow
						? qtee.customDesign.settings.newEl.background.scale
						: qtee.customDesign.settings.newEl.backgroundLampshade.scale,
					Width: that.isPillow
						? qtee.customDesign.settings.newEl.background.width
						: qtee.customDesign.settings.newEl.backgroundLampshade.width,
					Height: that.isPillow
						? qtee.customDesign.settings.newEl.background.height
						: qtee.customDesign.settings.newEl.backgroundLampshade.height,
					RotationalDegree: that.isPillow
						? qtee.customDesign.settings.newEl.background.rotation
						: qtee.customDesign.settings.newEl.backgroundLampshade.rotation,
					PatternImageUrl: pattern.PatternImageUrl,
					ZOrder: 0 // z-index is always zero for background layers, because they are last
				},
				{
					wait: false,
					success (r) {

						if (skipAdd) {

							stopLoader();
							that.$events.triggerHandler('add.history', [ [ r ] ]);
							return;

						}
						// server returned the actual size of pattern/design model
						qtee.customDesign.canvas.add(model, false, true).then(
							(el) => {

								that.canvasEl = el;
								that.$events.triggerHandler('showSuccessState', 'canvas element pattern was added');

							},
							(reason) => {

								that.$events.triggerHandler('showErrorState', reason);
								model.destroy();

							}
						);

						stopLoader();
						that.render();
						that.$events.triggerHandler('add.history', [ [ r ] ]);

					},
					error () {

						stopLoader();

					}
				}
			);

		}

	},
	backClick () {

		$('#newBackgroundElement').hide();
		$('.restartUndoGroup').addClass('active');
		// this.$events.triggerHandler('showDefaultSection');

	}
});
